import {Component, Input, OnChanges, AfterViewInit, ViewEncapsulation} from '@angular/core';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {Constants} from '../../constants';

declare var hbspt: any;

@Component({
    selector: 'app-form-template',
    templateUrl: './form-template.component.html',
    styleUrls: ['./form-template.component.scss']
})
export class FormTemplateComponent implements OnChanges, AfterViewInit {
    @Input() type: number;
    form: FormGroup;
    isAnual: boolean;

    constructor(
        private fb: FormBuilder
    ) {
    }

    ngAfterViewInit(): void {
        if (this.isAnual) {
            hbspt.forms.create({
                portalId: '5707307',
                formId: '7e696324-0976-48f7-8f66-575f45144449',
                target: '#formcontainer',
                cssClass: 'personal-form-item'
            });
        } else {
            hbspt.forms.create({
                portalId: '5707307',
                formId: '0e01eec6-507e-462b-9ed5-36c183fb632a',
                target: '#formcontainer',
                cssClass: 'personal-form-item'
            });
        }
    }

    ngOnChanges(): void {
        if (this.type) {
            this.isAnual = this.type === Constants.typePersonalAnual ? true : false;
            this.initForm();
        }
    }

    initForm(): void {
        switch (this.type) {
            case Constants.typePersonalMonth:
                this.form = this.fb.group({
                    name: ['', Validators.compose([Validators.required])],
                    lastName: ['', Validators.compose([Validators.required])],
                    email: ['', Validators.compose([Validators.required])],
                    phone: ['', Validators.compose([Validators.required])],
                    company: ['', Validators.compose([Validators.required])],
                    sector: ['', Validators.compose([Validators.required])],
                    transactionsPerComplement: ['', Validators.compose([Validators.required])],
                    video: [false, Validators.compose([Validators.required])],
                    sms: [false, Validators.compose([Validators.required])],
                    usaConstancy: [false, Validators.compose([Validators.required])],
                    etheriumConstancy: [false, Validators.compose([Validators.required])],
                    mexicoConstancy: [false, Validators.compose([Validators.required])],
                    ineValidation: [false, Validators.compose([Validators.required])],
                    inePhoto: [false, Validators.compose([Validators.required])],
                    signComparison: [false, Validators.compose([Validators.required])],
                    videoConstancy: [false, Validators.compose([Validators.required])],
                    videoSignConstancy: [false, Validators.compose([Validators.required])],
                });
                break;
            case Constants.typePersonalAnual:
                this.form = this.fb.group({
                    name: ['', Validators.compose([Validators.required])],
                    lastName: ['', Validators.compose([Validators.required])],
                    email: ['', Validators.compose([Validators.required])],
                    phone: ['', Validators.compose([Validators.required])],
                    company: ['', Validators.compose([Validators.required])],
                    sector: ['', Validators.compose([Validators.required])],
                    transactions: ['', Validators.compose([Validators.required])],
                    transactionsPerComplement: ['', Validators.compose([Validators.required])],
                    video: [false, Validators.compose([Validators.required])],
                    sms: [false, Validators.compose([Validators.required])],
                    usaConstancy: [false, Validators.compose([Validators.required])],
                    etheriumConstancy: [false, Validators.compose([Validators.required])],
                    mexicoConstancy: [false, Validators.compose([Validators.required])],
                    ineValidation: [false, Validators.compose([Validators.required])],
                    inePhoto: [false, Validators.compose([Validators.required])],
                    signComparison: [false, Validators.compose([Validators.required])],
                    videoConstancy: [false, Validators.compose([Validators.required])],
                    videoSignConstancy: [false, Validators.compose([Validators.required])],
                });
                break;
        }
    }

}
